"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidationBundler = void 0;
const ConstraintUtils_1 = require("../../ConstraintUtils");
class ValidationBundler {
    constructor(parentTag, myTag) {
        this.parentTag = parentTag;
        this.myTag = myTag;
    }
    getTag() {
        return this.parentTag != null ? this.parentTag + '.' + this.myTag : this.myTag;
    }
    toChecked(message) {
        return new ConstraintUtils_1.Checked(this.getTag(), ConstraintUtils_1.Status.ERROR, message);
    }
}
exports.ValidationBundler = ValidationBundler;
